import { IFolderPanelInfo } from "../../../interfaces/IFolderPanelInfo";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { FolderTypeEnum } from "../../enums/FolderTypeEnum";
import { OneDriveFolderPanelHelper } from "./OneDriveFolderPanelHelper";
import { SharepointFolderPanelHelper } from "./SharepointFolderPanelHelper";
import { TeamChannelFolderPanelHelper } from "./TeamChannelFolderPanelHelper";
import { IFolderPanelHelper } from "../../../interfaces/IFolderPanelHelper";
import { SharepointSubsitePanelHelper } from "./SharepointSubsitePanelHelper";
import { TeamMainFolderPanelHelper } from "./TeamMainFolderPanelHelper";

export class FolderPanelHelperFactory {
    constructor(private addWorkingDirectory: (location: IPageSettings) => {
        type: "ADD_WORKING_DIRECTORY";
        payload: IPageSettings;
    }, private addWorkingDirectories: (locations: IPageSettings[]) => {
        type: "ADD_WORKING_DIRECTORIES";
        payload: IPageSettings[];
    }, private folderType: FolderTypeEnum
    ) { }

    create(folderPanelInfo: IFolderPanelInfo, currentDirectory: IPageSettings, languageStrings?: any): IFolderPanelHelper {
        switch (this.folderType) {
            case FolderTypeEnum.oneDrive:
                return new OneDriveFolderPanelHelper(folderPanelInfo, currentDirectory, this.addWorkingDirectory, this.addWorkingDirectories);
            case FolderTypeEnum.sharepoint:
                return new SharepointFolderPanelHelper(folderPanelInfo, currentDirectory, this.addWorkingDirectory, languageStrings);
            case FolderTypeEnum.teamChannel:
                return new TeamChannelFolderPanelHelper(this.addWorkingDirectory, folderPanelInfo, currentDirectory, languageStrings);
            case FolderTypeEnum.teamMainSite:
                return new TeamMainFolderPanelHelper(folderPanelInfo, currentDirectory);
            case FolderTypeEnum.oneDriveSubFolder:
                return new OneDriveFolderPanelHelper(folderPanelInfo, currentDirectory, this.addWorkingDirectory, this.addWorkingDirectories);
            default:
                return new SharepointSubsitePanelHelper(folderPanelInfo, currentDirectory);
        }
    }
}